import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { TbBarcodeOff } from 'react-icons/tb';
import dayjs from 'dayjs'; // Import dayjs for date formatting
import { MdOutlineManageHistory } from 'react-icons/md';
import { BiBarcodeReader } from 'react-icons/bi';
import { Modal } from 'bootstrap';
import { jsPDF } from 'jspdf';

export default function EmergencyBarcode() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, subjectId, examname, subjectname } = location.state || {};
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([{}]);
  const [barcodeCount, setBarcodeCount] = useState('');
  const modalRef = useRef(); // Reference for the modal
  const [extraBarcode, setExtrabarcode] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editBarcode, setEditBarcode] = useState({
    barcodeNo: '',
    name: '',
    rollNumber: '',
    reason: '',
  });
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);
  useEffect(() => {
    fetchRecordHistory();
  }, []);
  const fetchRecordHistory = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    let data = JSON.stringify({
      examId: id,
      subjectId: subjectId,
    });
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/emergencyBarcode/list`,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        setHistory(response.data.data);
        setCount(response.data.count);
      })
      .catch((error) => {
        setLoading(false);
        setHistory([]);
        error.response?.status === 401 && navigate('/');
      });
  };
  const formatDate = (dateString) => {
    return dayjs(dateString).format('DD/MM/YYYY');
  };
  const historyColumns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Emergency',
      selector: (row) => row.emergencyBarcodeNo,
      sortable: true,
      center: 'true',
    },
    {
      name: ' Barcode No',
      selector: (row) => row.qrCodeBarcodeNo,
      sortable: true,
      center: 'true',
    },
    {
      name: 'Roll No',
      selector: (row) => row.studentRollNumber,
      sortable: true,
      width: '90px',
      center: 'true',
    },
    {
      name: 'Name',
      selector: (row) => row.studentName,
      sortable: true,
    },
    {
      name: 'Date',
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
      center: 'true',
    },
    {
      name: 'Created By',
      selector: (row) => row.createdByName,
      sortable: true,
      center: 'true',
    },
    {
      name: 'Reason',
      selector: (row) => row.reason,
      sortable: true,
      center: 'true',
    },
    {
      name: 'Action',
      selector: (row) => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => handleEditClick(row.id, row.studentName)}
        >
          <i className="bi bi-pencil-square"></i>
        </button>
      ),
      sortable: false,
      width: '70px',
      center: 'true',
    },
  ];
  useEffect(() => {
    const editModal = document.getElementById('editModal');
    // Add event listener to clear form when modal is hidden
    editModal.addEventListener('hidden.bs.modal', () => {
      // Reset form data here
      setEditBarcode({
        barcodeNo: '',
        rollNumber: '',
        reason: '',
      });
    });
    // Cleanup the event listener when the component is unmounted
    return () => {
      editModal.removeEventListener('hidden.bs.modal', () => {});
    };
  }, []);
  const handleEditClick = async (barcodeId) => {
    try {
      const token = localStorage.getItem('token');
      const data = JSON.stringify({ id: barcodeId });
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/emergencyBarcode/details`,
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'application/json',
        },
        data: data,
      };
      const response = await axios.request(config);
      setEditBarcode(response.data);
      // Initialize and show the modal
      const modal = new window.bootstrap.Modal(
        document.getElementById('editModal')
      );
      modal.show();
    } catch (error) {
      console.error('Error fetching barcode details:', error);
      error.response?.status === 401 && navigate('/');
      toast.error('Failed to fetch barcode details.');
    }
  };
  const handleSaveChanges = async () => {
    const token = localStorage.getItem('token');
    const parsedRollNumber = editBarcode.rollNumber;
    const data = JSON.stringify({
      examId: id,
      subjectId: subjectId,
      barcodeNo: editBarcode.barcodeNo,
      rollNumber: parsedRollNumber,
      reason: editBarcode.reason,
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/emergencyBarcode/update`,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    };
    try {
      await axios.request(config);
      toast.success('Barcode details updated successfully');
      // Close the modal
      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById('editModal')
      );
      modal.hide();
      // Refresh the data
      fetchRecordHistory();
    } catch (error) {
      console.error('Error updating barcode details:', error);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };
  const ExtraBarcode = async () => {
    const token = localStorage.getItem('token');
    const info = JSON.stringify({
      examId: id,
      subjectId: subjectId,
      count: parseInt(barcodeCount), // Default to 2 if input is empty
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/emergencyBarcode`,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      data: info,
    };
    try {
      const response = await axios.request(config);
      setExtrabarcode(response.data);
      setBarcodeCount('');
      toast.success('Barcode generated successfully');
      fetchRecordHistory();
    } catch (error) {
      console.error('Error in ExtraBarcode:', error);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };
  // Ensure the modal is shown after setting modalData
  useEffect(() => {
    if (modalData.length > 0) {
      const modal = Modal.getOrCreateInstance(modalRef.current); // Ensure modal instance is created
      modal.show(); // Show the modal after data is set
    }
  }, [modalData]);

  const handleSendBarcodeNos = async () => {
    const token = localStorage.getItem('token');
    const barcodeNos = selectedRows.map((row) => row.emergencyBarcodeNo); // Extract barcodeNo from selected rows
    const config = {
      method: 'post',
      url: `${apiUrl}/api/emergencyBarcode/records`,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        barcodeNos: barcodeNos,
      }),
    };

    try {
      const response = await axios.request(config);

      // Set modal data, useEffect will handle showing the modal
      setModalData(response.data.data);

      toast.success('Barcodes sent successfully');

      // Clear selected rows
      setSelectedRows([]);
      setClearSelectedRows(!clearSelectedRows);
    } catch (error) {
      console.error('Error sending barcodes:', error);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };

  const handleRollNumberBlur = async () => {
    const token = localStorage.getItem('token');
    try {
      // Convert rollNumber to a number
      const rollNumber = editBarcode.rollNumber;
      // Check if rollNumber is valid
      if (isNaN(rollNumber)) {
        console.error('Invalid roll number');
        return;
      }
      const data = JSON.stringify({
        examId: id, // Adjust as needed
        rollNumber: rollNumber, // Send as a number
      });
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/students/getstudent`,
        headers: {
          Authorization: ` ${token}`, // Ensure the token format is correct
          'Content-Type': 'application/json',
        },
        data: data,
      };
      const response = await axios.request(config);
      const studentName = response.data.name; // Adjust based on actual response structure
      setEditBarcode((prevState) => ({
        ...prevState,
        name: studentName,
      }));
      <hr className="mb-0" />;
    } catch (error) {
      console.error('Error fetching student details:', error);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };
  const ERDownloadPDF = (barcodes, examname) => {
    // Initialize jsPDF object with a specific page size
    const pdf = new jsPDF('landscape', 'cm', [10, 2.5]); // Set page size to 10cm width x 2.5cm height

    // Loop through the barcodes and add their details to the PDF
    barcodes.forEach((barcode, index) => {
      // Reset position for each barcode section
      let yPosition = 0.6; // Starting Y position with a margin
      const leftColumnX = 0.4; // X position for text

      // Set font for the text details
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      const labelWidth = 1.5; // Minimum width for labels in cm
      const padding = 0.0; // Optional padding between label and data

      // Add Roll No, Exam, Subject, and Sub Code
      pdf.text(`Roll No:`, leftColumnX, yPosition);
      pdf.text(`${''}`, leftColumnX + labelWidth + padding, yPosition); // Placeholder for roll number
      yPosition += 0.5;
      pdf.text(`Exam:`, leftColumnX, yPosition); // Use 'examname' instead of 'examName'
      pdf.text(`${examname}`, leftColumnX + labelWidth + padding, yPosition); // Place data after label
      yPosition += 0.5;
      pdf.text(`Subject:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.barcodeJson.subjectName}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;
      pdf.text(`Sub Code:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.barcodeJson.subjectCode}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;

      // Add Barcode image if available
      if (barcode.barcodeJson.barcodeImage) {
        const base64Image = barcode.barcodeJson.barcodeImage;

        // Ensure the image has the correct base64 prefix
        if (base64Image.startsWith('data:image/')) {
          pdf.addImage(base64Image, 'PNG', 6, 0.3, 3.5, 1.5); // Adjust position and size (X, Y, Width, Height)
        } else {
          console.error('Invalid base64 image format:', base64Image);
        }
      }

      // Add the barcode number below the image, centered
      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo}`, 7.8, 2.1, { align: 'center' });

      // Add a new page for the next barcode if not the last one
      if (index !== barcodes.length - 1) {
        pdf.addPage();
      }
    });

    // Save the generated PDF file
    pdf.save('barcodes.pdf');
  };
  const ERDownloadPDFA4 = (barcodes, examname) => {
    const pdf = new jsPDF('portrait', 'cm', [21, 29.7]); // A4 size in portrait mode

    const truncateText = (text, maxLength) => {
      return text.length > maxLength
        ? text.substring(0, maxLength) + '...'
        : text;
    };

    const maxLength = 25; // Max length for truncating text
    const columns = 2; // Two barcodes per row
    const rows = 8; // Eight rows per page
    const barcodeWidth = 9.5; // Width for each barcode section (cm)
    const barcodeHeight = 3; // Height for each barcode section (cm)
    const labelWidth = 1.5; // Minimum width for labels in cm
    const padding = 0.2; // Padding between label and data
    const marginTop = -2.4; // Margin to add to the top of the barcode image
    const columnGap = 1.4; // Gap between columns (in cm)
    const pageTopMargin = 1.5; // Top margin for the page (in cm)
    const rowGap = 0.5; // Gap between rows (in cm)

    let yPosition = pageTopMargin; // Start the y-position from the top margin

    barcodes.forEach((barcode, index) => {
      const column = index % columns; // Determine column (0 or 1)
      const row = Math.floor(index / columns) % rows; // Determine row (0 to 7)

      // Reset yPosition and add a new page when required
      if (index > 0 && row === 0 && column === 0) {
        pdf.addPage();
        yPosition = pageTopMargin; // Reset yPosition for the new page
      }

      let xPosition = column * (barcodeWidth + columnGap) + 0.4; // X position for text and barcode
      yPosition = pageTopMargin + row * (barcodeHeight + rowGap) + 0.6; // Y position for text and barcode

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      // Add Roll No, Exam, Subject, and Sub Code
      pdf.text(`Roll No:`, xPosition, yPosition);
      pdf.text(
        `${barcode.studentRollNumber || ''}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Exam:`, xPosition, yPosition);
      const truncatedExamName = truncateText(examname, maxLength);
      pdf.text(
        `${truncatedExamName}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Subject:`, xPosition, yPosition);
      const subjectName = barcode.barcodeJson?.subjectName || '';
      const truncatedSubjectName = truncateText(subjectName, maxLength);
      pdf.text(
        `${truncatedSubjectName}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Sub Code:`, xPosition, yPosition);
      pdf.text(
        `${barcode.barcodeJson?.subjectCode || ''}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Barcode image if available
      if (barcode.barcodeJson?.barcodeImage) {
        const base64Image = barcode.barcodeJson.barcodeImage;

        if (base64Image.startsWith('data:image/')) {
          pdf.addImage(
            base64Image,
            'PNG',
            xPosition + 6,
            yPosition + marginTop,
            3.6,
            1.9
          ); // Adjust X, Y, Width, Height
          yPosition += 1.5; // Move the y-position after placing the barcode image
        } else {
          console.error('Invalid base64 image format:', base64Image);
        }
      }

      // Add the barcode number below the image, centered
      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo || ''}`, xPosition + 7.8, yPosition - 1.7, {
        align: 'center',
      });
    });

    pdf.save('barcodes_a4_format.pdf');
  };

  // Function to generate a PDF containing barcodes with student details
  const handleDownloadPDF = (barcodes, examname) => {
    // Initialize jsPDF object with a specific page size
    const pdf = new jsPDF('landscape', 'cm', [10, 2.5]); // Set page size to 10cm width x 2.5cm height

    // Helper function to add the barcode image once it's loaded
    const addImageToPDF = (img, pdf, x, y, width, height) => {
      pdf.addImage(img, 'PNG', x, y, width, height);
    };

    // Loop through the barcodes and add their details to the PDF
    barcodes.forEach((barcode, index) => {
      // Reset position for each barcode section
      let yPosition = 0.6; // Starting Y position with a margin
      const leftColumnX = 0.4; // X position for text

      // Set font for the text details
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      const labelWidth = 1.5; // Minimum width for labels in cm
      const padding = 0.0; // Optional padding between label and data

      // Add Roll No, Exam, Subject, and Sub Code
      pdf.text(`Roll No:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.studentRollNumber}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;
      pdf.text(`Exam:`, leftColumnX, yPosition); // Use 'examname' instead of 'examName'
      pdf.text(`${examname}`, leftColumnX + labelWidth + padding, yPosition); // Place data after label
      yPosition += 0.5;
      pdf.text(`Subject:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.subjectName}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;
      pdf.text(`Sub Code:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.subjectCode}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;

      // Add Barcode image if available
      if (barcode.barcodeJson?.barcodeImage) {
        const img = new Image();
        img.src = barcode.barcodeJson.barcodeImage;

        // Ensure the image is fully loaded before adding it to the PDF
        img.onload = () => {
          addImageToPDF(img, pdf, 6, 0.3, 3.5, 1.5); // Adjust position and size (X, Y, Width, Height)

          // Add the barcode number below the image, centered
          pdf.setFontSize(10);
          pdf.text(`${barcode.barcodeNo}`, 7.8, 2.1, { align: 'center' });

          // Add a new page for the next barcode if not the last one
          if (index !== barcodes.length - 1) {
            pdf.addPage();
          }

          // Check if it's the last barcode and save the PDF when finished
          if (index === barcodes.length - 1) {
            pdf.save('barcodes.pdf');
          }
        };
      } else {
        // If there's no barcode image, continue to the next barcode
        if (index !== barcodes.length - 1) {
          pdf.addPage();
        }

        // Check if it's the last barcode and save the PDF when finished
        if (index === barcodes.length - 1) {
          pdf.save('barcodes.pdf');
        }
      }
    });
  };

  const handleDownloadPDF4 = (barcodes, examname) => {
    const pdf = new jsPDF('portrait', 'cm', [21, 29.7]); // A4 size in portrait

    const truncateText = (text, maxLength) => {
      return text.length > maxLength ? text.substring(0, maxLength) + '' : text;
    };

    const maxLength = 25; // Max length for truncating text
    const columns = 2; // Two barcodes per row
    const rows = 8; // Eight rows per page
    const barcodeWidth = 9.5; // Width for each barcode section (cm)
    const barcodeHeight = 3; // Height for each barcode section (cm)
    const labelWidth = 1.5; // Minimum width for labels in cm
    const padding = 0.2; // Padding between label and data
    const marginTop = -2.4; // Margin to add to the top of the barcode image
    const columnGap = 1.4; // Gap between columns (in cm)
    const pageTopMargin = 1.5; // Top margin for the page (in cm)
    const rowGap = 0.5; // Gap between rows (in cm)

    let yPosition = pageTopMargin; // Start the y-position from the top margin

    barcodes.forEach((barcode, index) => {
      const column = index % columns; // Determine column (0 or 1)
      const row = Math.floor(index / columns) % rows; // Determine row (0 to 7)

      // Reset yPosition and add a new page when required
      if (index > 0 && row === 0 && column === 0) {
        pdf.addPage();
        yPosition = pageTopMargin; // Reset yPosition for the new page
      }

      let xPosition = column * (barcodeWidth + columnGap) + 0.4; // X position for text and barcode
      yPosition = pageTopMargin + row * (barcodeHeight + rowGap) + 0.6; // Y position for text and barcode

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      // Add Roll No
      pdf.text(`Roll No:`, xPosition, yPosition);
      pdf.text(
        `${barcode.studentRollNumber}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Exam Name
      pdf.text(`Exam:`, xPosition, yPosition);
      const truncatedExamName = truncateText(examname, maxLength);
      pdf.text(
        `${truncatedExamName} `,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Subject Name
      pdf.text(`Subject:`, xPosition, yPosition);
      const truncatedSubjectName = truncateText(barcode.subjectName, maxLength);
      pdf.text(
        `${truncatedSubjectName}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Subject Code
      pdf.text(`Sub Code:`, xPosition, yPosition);
      pdf.text(
        `${barcode.subjectCode}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Barcode Image
      const barcodeImage = barcode.barcodeJson?.barcodeImage;
      if (barcodeImage && barcodeImage.startsWith('data:image/')) {
        try {
          pdf.addImage(
            barcodeImage,
            'PNG',
            xPosition + 6,
            yPosition + marginTop,
            3.6,
            1.9
          ); // Adjust X, Y, Width, Height
          yPosition += 1.5; // Move the y-position after placing the barcode image
        } catch (error) {
          console.error('Error adding barcode image:', error);
        }
      } else {
        console.error('Invalid or missing barcode image:', barcodeImage);
      }

      // Add Barcode Number
      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo}`, xPosition + 7.8, yPosition - 1.7, {
        align: 'center',
      });
    });

    pdf.save('barcodes.pdf');
  };

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li
                className="breadcrumb-item  cursor-pointer"
                onClick={() => navigate('/ListExam')}
              >
                View Exam
              </li>
              <li
                className="breadcrumb-item cursor-pointer "
                onClick={() =>
                  navigate('/ExamDetails', {
                    state: { id, subjectId, examname },
                  })
                }
              >
                Exam Subjects
              </li>
              <li className="breadcrumb-item active">
                {' '}
                Emergency Barcodes {subjectname} ({count})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <div className="row">
          <div className="container ">
            <div className="datatable-top">
              <div className="d-flex flex-row ">
                <div className="">
                  <div className="datatable-search">
                    <input
                      className="form-control"
                      type="search"
                      placeholder="Search"
                      title="Search within table"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className=" bd-highlight d-flex  col-sm-5">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Emergency Barcode"
                  value={barcodeCount}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setBarcodeCount(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-primary ms-2 btn-sm"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Upload Question Paper & Answer Key"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={ExtraBarcode}
                >
                  Emergency
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-circle btn-sm ms-2 p-1 "
                  onClick={() =>
                    navigate('/WithoutBarcode', {
                      state: { id, subjectId, examname, subjectname },
                    })
                  }
                >
                  {' '}
                  <TbBarcodeOff className="barcode-nav-buuton" />
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-circle btn-sm ms-2 p-1 "
                  onClick={() =>
                    navigate('/WithBarcode', {
                      state: { id, subjectId, examname, subjectname },
                    })
                  }
                >
                  {' '}
                  <BiBarcodeReader className="barcode-nav-buuton" />
                </button>
                <button
                  type="button"
                  className="btn  border border-dark rounded-circle btn-sm ms-2 p-1 "
                  onClick={() =>
                    navigate('/EmergencyBarcode', {
                      state: { id, subjectId, examname, subjectname },
                    })
                  }
                >
                  {' '}
                  <MdOutlineManageHistory className="barcode-nav-buuton" />
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable
                columns={historyColumns}
                data={history}
                progressPending={loading}
                pagination
                selectableRows
                onSelectedRowsChange={(state) =>
                  setSelectedRows(state.selectedRows)
                }
                clearSelectedRows={clearSelectedRows}
                className="custom-table"
                paginationPerPage={rowsPerPage} // Set rows per page
                paginationTotalRows={history.length} // Total number of records
                paginationDefaultPage={currentPage} // Default starting page
                onChangePage={(page) => setCurrentPage(page)} // Update current page
                onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)} // Update rows per page
              />
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={handleSendBarcodeNos}
                >
                  <i className="bi bi-qr-code-scan"></i> Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Modal for editing barcode details */}
      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-labelledby="editModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editModalLabel">
                Edit Barcode Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {editBarcode && (
                <form>
                  <div className="mb-3">
                    <label htmlFor="rollNumber" className="form-label">
                      Roll Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="text"
                      value={editBarcode.rollNumber}
                      onChange={(e) =>
                        setEditBarcode({
                          ...editBarcode,
                          rollNumber: e.target.value,
                        })
                      }
                      onBlur={handleRollNumberBlur}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="studentName" className="form-label">
                      Student Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="studentName"
                      value={editBarcode?.name || ''} // Safely accessing studentName
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="barcodeNo" className="form-label">
                      Barcode No
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="barcodeNo"
                      value={editBarcode.barcodeNo}
                      onChange={(e) =>
                        setEditBarcode({
                          ...editBarcode,
                          barcodeNo: e.target.value,
                        })
                      }
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="reason" className="form-label">
                      Reason
                    </label>
                    <textarea
                      className="form-control"
                      id="reason"
                      value={editBarcode.reason}
                      onChange={(e) =>
                        setEditBarcode({
                          ...editBarcode,
                          reason: e.target.value,
                        })
                      }
                    />
                  </div>
                </form>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveChanges}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal for Extra Barcode */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <h5
                className="modal-title text-white p-1 rounded"
                id="exampleModalLabel"
              >
                Generate Emergency Barcodes
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {extraBarcode.length > 0 ? (
                extraBarcode.map((barcode, index) => (
                  <div key={barcode.id} className="mb-3">
                    <div className="container d-flex justify-content-center align-items-center ">
                      <div className="border border-dark p-1 w-75">
                        <div className="row">
                          <div className="col mt-2">
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Roll No: </strong>
                              </div>
                              <div className="">
                                <span></span>
                              </div>
                            </div>
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Exam: </strong>
                              </div>
                              <div className="">
                                <span> {examname}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Subject:</strong>
                              </div>
                              <div className="">
                                <span> {barcode.barcodeJson.subjectName}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Sub Code: </strong>
                              </div>
                              <div className="">
                                <span> {barcode.barcodeJson.subjectCode}</span>
                              </div>
                            </div>
                          </div>
                          <div className="col text-end">
                            <div className="text-center">
                              <img
                                src={barcode.barcodeJson.barcodeImage}
                                alt={`Barcode ${index + 1}`}
                                style={{
                                  width: '250px',
                                  height: '100px',
                                  marginBottom: '-7px',
                                }}
                              />
                              <p className="mb-1 mt-0">
                                <strong className="text-danger">
                                  {barcode.barcodeNo}
                                </strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No barcodes generated yet.</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success mx-1"
                onClick={() => ERDownloadPDF(extraBarcode, examname)} // This calls the function to generate the PDF
              >
                PDf 100 X 25 aa
              </button>
              <button
                type="button"
                className="btn btn-success mx-1"
                onClick={() => ERDownloadPDFA4(extraBarcode, examname)} // This calls the function to generate the PDF
              >
                A4 21 X 29.7
              </button>

              <button
                type="button"
                className="btn btn-secondary mx-1"
                data-bs-dismiss="modal"
                onClick={() => setExtrabarcode([])}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal for Details Barcode */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <h5
                className="modal-title text-white p-1 rounded"
                id="exampleModalLabel"
              >
                Regretted Emergency Barcodes
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {modalData.length > 0 ? (
                modalData.map((barcode, index) => (
                  <div key={barcode.id} className="mb-3">
                    <div className="container d-flex justify-content-center align-items-center">
                      <div className="border border-dark  p-1 w-75">
                        <div className="row">
                          <div className="col mt-2">
                            <div className="d-flex flex-row">
                              <div className="barcode-labal">
                                <strong>Roll No: </strong>
                              </div>
                              <div className="">
                                <span>{barcode.studentRollNumber}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row">
                              <div className="barcode-labal">
                                <strong>Exam: </strong>
                              </div>
                              <div className="">
                                <span>{examname}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row">
                              <div className="barcode-labal">
                                <strong>Subject: </strong>
                              </div>
                              <div className="">
                                <span>{barcode.subjectName}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row">
                              <div className="barcode-labal">
                                <strong>Sub Code: </strong>
                              </div>
                              <div className="">
                                <span>{barcode.subjectCode}</span>
                              </div>
                            </div>
                          </div>
                          <div className="col text-end">
                            <div className="text-center">
                              <img
                                src={barcode.barcodeJson.barcodeImage}
                                alt={`Barcode ${index + 1}`}
                                style={{
                                  width: '250px',
                                  height: '100px',
                                  marginBottom: '-7px',
                                }}
                              />
                              <p className="mb-1 mt-0">
                                <strong className="text-danger">
                                  {barcode.barcodeNo}
                                </strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No barcodes available.</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success mx-1"
                onClick={() => handleDownloadPDF(modalData, examname)} // This calls the function to generate the PDF
              >
                PDf 100 X 25
              </button>
              <button
                type="button"
                className="btn btn-success mx-1"
                onClick={() => handleDownloadPDF4(modalData, examname)} // This calls the function to generate the PDF
              >
                A4 21 X 29.7
              </button>
              <button
                type="button"
                className="btn btn-secondary mx-1"
                data-bs-dismiss="modal"
                onClick={() => setModalData([])}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" style={{ width: 'auto' }} />
    </AdminLayout>
  );
}
